/* vk-mail.js v2 — Vedika: E-Mail-Adressen erst im Browser zusammensetzen (Schutz vor Adress-Scrapern)
   + Honeypot-Sperre für das Kontaktformular.
   Im Inhalt entweder <span class="vk-mail" data-u="info" data-d="vedika.ch">info [at] vedika.ch</span>
   oder schlicht der Text «info [at] vedika.ch» (in footer, .rte, .contact-form, main). */
(function () {
  var RE = /([A-Za-z0-9._+-]+) \[at\] ([A-Za-z0-9.-]+\.[A-Za-z]{2,})/;
  function link(addr) {
    var a = document.createElement('a');
    a.href = 'mailto:' + addr;
    a.textContent = addr;
    a.className = 'vk-mail-link';
    return a;
  }
  function render() {
    document.querySelectorAll('span.vk-mail[data-u][data-d]').forEach(function (s) {
      s.replaceWith(link(s.getAttribute('data-u') + '@' + s.getAttribute('data-d')));
    });
    var roots = document.querySelectorAll('footer, .rte, main');
    for (var i = 0; i < roots.length; i++) {
      var w = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT);
      var nodes = [], n;
      while ((n = w.nextNode())) if (RE.test(n.nodeValue)) nodes.push(n);
      nodes.forEach(function (t) {
        if (t.parentNode && t.parentNode.closest && t.parentNode.closest('a, script, style, textarea, input')) return;
        var m = RE.exec(t.nodeValue);
        var before = t.nodeValue.slice(0, m.index), after = t.nodeValue.slice(m.index + m[0].length);
        var frag = document.createDocumentFragment();
        if (before) frag.appendChild(document.createTextNode(before));
        frag.appendChild(link(m[1] + '@' + m[2]));
        if (after) frag.appendChild(document.createTextNode(after));
        t.replaceWith(frag);
      });
    }
  }
  function start() {
    render();
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; render(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Honeypot: Bots füllen jedes Feld — ist das unsichtbare Feld gefüllt, wird nicht abgeschickt
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    var hp = f.querySelector('input[name="contact[b_comment]"]');
    if (hp && hp.value.trim() !== '') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();
